<template>
  <v-alert
    v-model="config.show"
    prominent
    :icon="config.icon"
    dense
    dismissible
    :type="config.type || 'error'"
    transition="scale-transition"
  >
    <v-layout align-center wrap>
      <div>{{ config.message }}</div>
    </v-layout>
  </v-alert>
</template>

<script>
export default {
  name: 'alert',
  props: {
    config: {
      type: Object,
      default: null
    }
  }
};
</script>
